<div class="overlay">
  <div class="modal">
    <button class="close-modal" (click)="handleCloseModal(1)"><mat-icon>close</mat-icon></button>
    <div class="modal-header">
      <div class="tabs">
        <span class="tab" [ngClass]="{'active': stepForm === 1}">INFORMAÇÕES</span>
        <span class="tab" [ngClass]="{'active': stepForm === 2}">CANAIS</span>
        <span class="tab" [ngClass]="{'active': stepForm === 3}">AGENDAMENTOS</span>
      </div>
    </div>
    <div class="modal-body">
      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 1}">
        <form [formGroup]="formOficialQueue">
          <div class="form-group">
            <label for="csv-upload">Selecione uma lista: *</label>
            <select formControlName="idLista">
              <option *ngFor="let list of listGroup" [value]="list.idlist">{{list.nome}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="template-id">Informe o id Template: *</label>
            <input type="number" id="template-id" min="1" placeholder="Digite o template ID"
              formControlName="idTemplate" />
            <small>Digite o template ID da sua mensagem.</small>
            <small style="color: red"
              *ngIf="formOficialQueue.get('idTemplate')?.errors?.['required'] && formOficialQueue.get('idTemplate')?.touched">E
              Obrigatorio informar um ID de Template.</small>
          </div>
          <!-- <div class="form-group checkbox-group">
            <label>
              <input type="checkbox" id="ignore-header" formControlName="ignoreRow" />
              Ignorar primeira linha
            </label>
          </div> -->
          <!-- <div class="form-group">
            <label for="phone-column">Coluna do Telefone: *</label>
            <select id="phone-column" formControlName="colunaTelefone">
              <option value="" disabled selected>Selecione uma coluna</option>
              <option *ngFor="let column of columns" [value]="column.value">{{column.column}}</option>
            </select>
            <small>Selecione a coluna do telefone.</small>
          </div> -->
          <div class="form-group">
            <label for="country-select">Selecione o País: *</label>
            <select id="country-select">
              <option *ngFor="let country of countrys" [value]="country.code">{{country.name}}</option>
            </select>
            <small>Selecione o país para qual pretende disparar.</small>
          </div>
          <div class="modal-footer">
            <button class="btn cancel" (click)="handleCloseModal(1)">CANCELAR</button>
            <button class="btn continue" [disabled]="!handleValidStepOne()"
              [ngClass]="{'inactive-button':!handleValidStepOne()}" (click)="nextStep()">CONTINUAR</button>
          </div>
        </form>
      </div>

      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 2}">
        <form [formGroup]="formOficialQueue">
          <div>
            <div class="channels-container">
              <label for="channels">Canais que deseja disparar: *</label>
              <div class="channel" *ngFor="let canal of listChannels">
                <input type="checkbox" [value]="canal.idcanal" class="checkbox"
                  [disabled]="canal.status === 'Desconectado'" (change)="handleSelectChannel($event)">
                <label for="channel-1" class="channel-label">
                  <span class="channel-name">{{canal.nomefila}}</span>
                  <span class="status"
                    [ngClass]="{'connected': canal.status === 'Conectado', 'disconnected' : canal.status === 'Desconectado'}">{{canal.status}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn cancel" (click)="previousStep()">CANCELAR</button>
            <button class="btn continue" [ngClass]="{'inactive-button': !handleValidStepTwo()}"
              [disabled]="!handleValidStepTwo()" (click)="nextStep()">CONTINUAR</button>
          </div>
        </form>
      </div>

      <div class="form-disparo-step" [ngClass]="{'active': stepForm === 3}">
        <form [formGroup]="formOficialQueue">
          <div class="form-group">
            <div>
              <label>Envio personalizado: *</label>
              <div class="form-disparo-row">
                <div class="line-agendamento">
                  <label class="line-agendamento">
                    <input type="checkbox" (change)="handleIsScheduled($event)" />
                    Agendar Envio
                  </label>
                  <input *ngIf="isScheduled" class="input-time" type="time" (change)="handleManualyTimeData($event)" />
                  <input *ngIf="isScheduled" type="date" placeholder="DD/MM/YYYY" [ngModel]="formattedDate"
                    class="input-date" (change)="handleManualyDateData($event)"
                    [ngModelOptions]="{ standalone: true }" />
                </div>
              </div>
              <div class="form-disparo-row">
                <div class="line-agendamento">
                  <label class="line-agendamento">
                    <input type="checkbox" formControlName="hComercial" />
                    Disparar somente em horario comercial (08:00 as 19:00)

                  </label>
                </div>
              </div>
              <!-- <div class="form-disparo-row">
                <div class="line-agendamento">
                  <label class="line-agendamento">
                    <input type="checkbox" formControlName="antiSpam" />
                    Sistema Anti-Spam (Codigo Final da Mensagem)
                  </label>
                </div>
              </div> -->
              <div class="form-disparo-row">
                <div class="line-agendamento">
                  <label class="line-agendamento">
                    <input type="checkbox" formControlName="sunday" />
                    Disparar aos Domingos
                  </label>
                </div>
              </div>
              <!-- <div class="form-disparo-row">
                <div class="line-agendamento">
                  <label class="line-agendamento">
                    <input type="checkbox" formControlName="saturday" />
                    Disparar aos Sabados
                  </label>
                </div>
              </div> -->
              <div class="form-disparo-row">
                <div class="line-agendamento">
                  <label class="line-agendamento">
                    <input type="checkbox" id="" [(ngModel)]="acceptTerm" [ngModelOptions]="{standalone: true}" />
                    Concordo com os Termos do <a href="https://www.whatsapp.com/legal/terms-of-service?lang=pt_BR"
                      target="_blank">Whatsapp
                      <strong style="color: red;">*</strong></a>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn cancel" (click)="previousStep()">CANCELAR</button>
            <button class="btn continue" [disabled]="acceptTerm === false"
              [ngClass]="{'inactive-button' : acceptTerm === false}" (click)="handleSubmitFire()">CONTINUAR</button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>